import styled from "styled-components"

const UserTestimonialWrapper = styled.div`
    width: 100%;
    margin: 0 2%; 
    .message{
        background-color: #eaeaea;
        color: #053050;
        text-align: center;
        padding: 6vh 2vw;
        border-radius: 16px;
        line-height:1.5;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .img-name{
    display:flex;
    align-items: center;
    justify-content:center;
    gap: 16px;
    font-size: 1rem;
    font-weight: 600; 
        .name{
            text-align: center;
        }
        img{
            height: 50px;
            border-radius: 50%;
        }        
    }
`

const UserTestimonial = (props) => {
    return (
        <UserTestimonialWrapper>
            <p className="message">
                {props.message}
            </p>
            <div className="img-name">
                <img src={props.image} alt="Dp" />
                <p className="name">{props.name}</p>
            </div>
        </UserTestimonialWrapper>
    )
}

export default UserTestimonial;